import { useTranslation } from "react-i18next";

import type { CaptainUsageRow } from "./CaptainUsageTooltip";

import { useValueFormatter } from "@/utils/useValueFormatter";

export function CaptainUsageTable({ rows }: { rows: CaptainUsageRow[] }) {
  const { t } = useTranslation();
  const { format } = useValueFormatter();

  return (
    <table className="sr-only">
      <caption>{t("captainBilling.usage.tableCaption")}</caption>
      <thead>
        <tr>
          <th scope="col">{t("captainBilling.usage.month")}</th>
          <th scope="col">{t("captainBilling.usage.series.fromCap")}</th>
          <th scope="col">{t("captainBilling.usage.series.fromTopUp")}</th>
          <th scope="col">{t("captainBilling.usage.series.cap")}</th>
          <th scope="col">{t("captainBilling.usage.replies")}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.month}>
            <th scope="row">
              {row.longLabel}
              {row.isCurrent && ` (${t("captainBilling.usage.currentMonth")})`}
            </th>
            <td>{format(row.fromCap, "decimal")}</td>
            <td>{format(row.fromTopUp, "decimal")}</td>
            <td>{format(row.cap, "decimal")}</td>
            <td>{format(row.replies, "whole")}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
